import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams, useNavigate } from 'react-router-dom'
import Loader from '../../components/Loader'
import project_bg from '../../assets/ww.png'
import status_bar from '../../assets/status_bar.png'
import time from '../../assets/time.png'
import save_money from '../../assets/save_money.png'
import { GET_CAMPAIGN_DETAILS_RESET } from '../../redux/types'
import { get_single_campaign } from '../../redux/actions/campaignActions'
import { comma } from '../../utils/helper'
import { DateTime } from 'luxon'

const CampaignDetail = () => {
	const dispatch = useDispatch()

	const params = useParams()

	const navigate = useNavigate()

	const userAuth = useSelector((state) => state.userAuth)
	const { userDetail } = userAuth

	const getCampaignDetails = useSelector((state) => state.getCampaignDetails)
	const { loading, campaignDetails } = getCampaignDetails

	const clickHandler = (e) => {
		e.preventDefault()
		if (userDetail) {
			navigate('/user/dashboard/submissions/create')
		} else {
			navigate('/login')
			if (userDetail) {
				setTimeout(() => {
					navigate('/user/dashboard/submissions/create')
				}, 1000)
			}
		}
	}

	useEffect(() => {
		dispatch(get_single_campaign(params.slug))

		return () => {
			dispatch({ type: GET_CAMPAIGN_DETAILS_RESET })
		}
	}, [dispatch, params.slug])

	return (
		<>
			{loading ? (
				<Loader />
			) : campaignDetails ? (
				<>
					<section
						className='about_jumbo jumbo_section'
						style={{
							background: `url(${campaignDetails.banner})`,
							backgroundPosition: 'center',
						}}
					>
						<div className='container'>
							<div className='d-flex about_jumbo_text'>
								<div>
									<h1>Welcome To {campaignDetails.name} </h1>
								</div>
							</div>
						</div>
					</section>

					<section
						style={{ background: `url(${project_bg})` }}
						className='campaign_detail'
					>
						<div className='container'>
							<h5 className='text-center intro'>
								<strong> {campaignDetails.name} </strong>
								{campaignDetails.intro}
							</h5>

							<div className='row justify-content-center mb-5'>
								<div className='col-md-8'>
									<div className='campaign_detail_boxx'>
										<div className='row no-gutters'>
											<div className='col-lg-4 col-md-6'>
												<div className='text-center campaign_detail_div'>
													<img src={time} alt='' />
													<h6>Closing Date</h6>
													<p>
														{DateTime.fromISO(
															campaignDetails.endDate
														).toLocaleString(DateTime.DATETIME_MED)}{' '}
													</p>
												</div>
											</div>

											<div className='col-lg-4 col-md-6'>
												<div className='text-center campaign_detail_div'>
													<img src={save_money} alt='' />
													<h6>Budget</h6>
													<p>
														{campaignDetails.currency === 'naira' ? (
															<span>&#8358;</span>
														) : (
															<span>$</span>
														)}
														{comma(campaignDetails.amount)}
													</p>
												</div>
											</div>

											<div className='col-lg-4 col-md-6 ml-auto mr-auto'>
												<div className='text-center campaign_detail_div cdv'>
													<img src={status_bar} alt='' />
													<h6>Status</h6>
													<p> Accepting Submissions </p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className='container'>
							<h5>
								<strong>Campaign Description</strong>
							</h5>
							<p>{campaignDetails.details}</p>

							<div className='text-center mt-5'>
								<Link
									to='#'
									onClick={clickHandler}
									className='btn homepage_btn'
								>
									Submit Script
								</Link>
							</div>
						</div>
					</section>
				</>
			) : (
				<span>Nothing to display</span>
			)}
		</>
	)
}

export default CampaignDetail
